import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { ContactMechanismTypes } from '../../party/model/contact-mechanism-types.model';

@Injectable({
    providedIn: 'root'
})
export class ContactMechanismDataService extends DefaultDataService<ContactMechanismTypes> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService) {
        super('ContactMechanism', http, httpUrlGenerator);
    }

    override getAll(): Observable<ContactMechanismTypes[]> {
        const url = this.urlProvider.getUrl(EndPoints.contactMechanisms_indexContactMechanismTypes, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(<ContactMechanismTypes[]>res.body['contactMechanismTypes']);
                })
            );
    }
}
